import { StytchProvider } from "@stytch/react";
import { StytchUIClient } from "@stytch/vanilla-js";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import RouterContainer from "./containers/RouterContainer";

import * as Sentry from "@sentry/react";
import CustomFallback from "./components/CustomFallback";
import { Provider } from "./components/ui/provider";
import { initPostHog } from "./helpers/posthog";

const stytch = new StytchUIClient(import.meta.env.VITE_STYTCH_PUBLIC_TOKEN);

Sentry.init({
  dsn: "https://4a96486592df14dfda343b09a4ec17cb@o4509516442042368.ingest.us.sentry.io/4509539348971521",
  sendDefaultPii: true,
  integrations: [
    Sentry.replayIntegration({
      maskAllText: false,
      maskAllInputs: false,
      blockAllMedia: false,
    }),
  ],
  replaysSessionSampleRate: 1.0,
  allowUrls: ["portal.palomma.com"],
});

initPostHog();

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <StytchProvider stytch={stytch}>
      <Provider forcedTheme="light">
        <Sentry.ErrorBoundary fallback={<CustomFallback />}>
          <RouterContainer />
        </Sentry.ErrorBoundary>
      </Provider>
    </StytchProvider>
  </StrictMode>
);
